import { createSelector } from '@reduxjs/toolkit'

import { ServiceGroup } from '@/models/service'
import {
  mapSelectedElementHasVisibleSeatsSelector,
  mapSelectedElementServices,
} from '@/store/mapSlice'
import { servicesSlice } from '@/store/servicesSlice'
import { getVisibleServices } from '@/utils/getVisibleServices'

export const mapVisibleTicketGroupsSelector = createSelector(
  [
    mapSelectedElementServices,
    mapSelectedElementHasVisibleSeatsSelector,
    servicesSlice.selectors.data,
  ],
  (selectedElementServices, selectedElementHasVisibleSeats, servicesData) => {
    if (!servicesData) {
      return []
    }

    const visibleTicketServices = getVisibleServices({
      selectedElementHasVisibleSeats,
      services: selectedElementServices.ticketServices,
    })

    if (visibleTicketServices.length === 0) {
      return []
    }

    const servicesByGroupId = visibleTicketServices.reduce<
      Record<number, ServiceGroup['services']>
    >((acc, service) => {
      const groupServices = acc[service.serviceGroupId] ?? []
      groupServices.push(service)
      acc[service.serviceGroupId] = groupServices
      return acc
    }, {})

    return servicesData.serviceGroups
      .filter((group) => servicesByGroupId[group.serviceGroupId]?.length > 0)
      .map((group) => ({
        ...group,
        services: servicesByGroupId[group.serviceGroupId],
      }))
  }
)
